import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=680b0a2f&scoped=true&"
import script from "./CourseDetails.vue?vue&type=script&lang=js&"
export * from "./CourseDetails.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./CourseDetails.vue?vue&type=style&index=1&id=680b0a2f&scoped=true&lang=css&"
import style2 from "./CourseDetails.vue?vue&type=style&index=2&lang=css&"
import style3 from "@/assets/hometeacher/css/main.css?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680b0a2f",
  null
  
)

export default component.exports